// src/components/navbar/Topbar.js
import React from "react";
import { useInterval } from "contexts/IntervalContext";
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
} from "components/ui/dropdown-menu";
import { Bell, Search, ChevronDown, Settings } from "lucide-react";

export default function Topbar() {
  const { interval, setInterval } = useInterval();

  return (
    <header
      data-sheet-exclude
      className={`
        fixed top-0 left-64 right-0 h-14 
        bg-neutral-950/95 
        flex items-center justify-end px-6 gap-6 
        backdrop-blur-md z-[9500]
      `}
    >
      {/* 검색창 */}
       <div className="flex items-center gap-2 px-3 py-1 bg-neutral-900 rounded-md w-64">        <Search className="w-4 h-4 text-neutral-400" />
        <input
          type="text"
          placeholder="Search..."
          className="bg-transparent text-sm outline-none w-full text-neutral-300 placeholder-neutral-500"
        />
      </div>

      {/* 알림 */}
      <button className="text-neutral-400 hover:text-white transition-colors">
        <Bell className="w-5 h-5" />
      </button>

      {/* Interval 드롭다운 */}
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <button
            className="text-sm font-semibold text-neutral-300 hover:text-white flex items-center gap-1"
            data-sheet-exclude
          >
            <span>{interval.charAt(0).toUpperCase() + interval.slice(1)}</span>
            <ChevronDown className="w-4 h-4" />
          </button>
        </DropdownMenuTrigger>

        <DropdownMenuContent
          data-sheet-exclude
          align="end"
          sideOffset={8}
          className="z-[9600] bg-neutral-900 text-neutral-200 border border-neutral-800 rounded-lg shadow-lg"
        >
          <DropdownMenuItem data-sheet-exclude onClick={() => setInterval("daily")}>
            Daily
          </DropdownMenuItem>
          <DropdownMenuItem data-sheet-exclude onClick={() => setInterval("weekly")}>
            Weekly
          </DropdownMenuItem>
          <DropdownMenuItem data-sheet-exclude onClick={() => setInterval("monthly")}>
            Monthly
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>

      {/* Pro 뱃지 */}
      <span className="text-xs font-semibold bg-gradient-to-r from-yellow-400 to-yellow-500 text-white px-2.5 py-1 rounded-full shadow">
        Pro
      </span>

      {/* 설정 아이콘 */}
      <button className="text-neutral-400 hover:text-white transition-colors">
        <Settings className="w-5 h-5" />
      </button>

      {/* 프로필 */}
      {/* 프로필 */}
<DropdownMenu>
  <DropdownMenuTrigger asChild>
    <button
      data-sheet-exclude
      className="flex items-center gap-2 hover:bg-neutral-900 px-2 py-1 rounded-md transition-colors"
    >
      <img
        src="https://avatars.githubusercontent.com/u/000000?v=4"
        className="w-8 h-8 rounded-full border border-neutral-800"
        alt="profile"
      />
      <span className="hidden md:inline text-sm font-medium text-neutral-300">
        Chris
      </span>
    </button>
  </DropdownMenuTrigger>

  <DropdownMenuContent
    data-sheet-exclude
    align="end"
    sideOffset={8}
    className="z-[9600] bg-neutral-900 text-neutral-200 border border-neutral-800 rounded-lg shadow-lg w-40"
  >
    <DropdownMenuItem
      data-sheet-exclude
      onClick={() => console.log("Go to settings")}
      className="cursor-pointer hover:bg-neutral-800"
    >
      Settings
    </DropdownMenuItem>
    <DropdownMenuItem
      data-sheet-exclude
       onClick={() => {
   localStorage.removeItem("access_token");  // ✅ 토큰 삭제
   localStorage.removeItem("refresh_token"); // (있다면 이것도)
   window.location.href = "/login";          // ✅ 로그인 페이지로 리다이렉트
 }}
      className="cursor-pointer hover:bg-neutral-800 text-red-400"
    >
      Logout
    </DropdownMenuItem>
  </DropdownMenuContent>
</DropdownMenu>
    </header>
  );
}